import { render, staticRenderFns } from "./HubblePlotSvg.vue?vue&type=template&id=039ee8ea&scoped=true"
import script from "./HubblePlotSvg.vue?vue&type=script&lang=ts"
export * from "./HubblePlotSvg.vue?vue&type=script&lang=ts"
import style0 from "./HubblePlotSvg.vue?vue&type=style&index=0&id=039ee8ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ee8ea",
  null
  
)

export default component.exports